<template>
    <q-layout view="hHh lpR fFf">
        <q-page-container>
            <q-page>
                <EvalIntro v-if="showIntro" @on-start="gotoEvalTest" />
                <div v-if="!showIntro" class="row">
                    <div class="col col--left">
                        <div class="logo__content">
                            <h1 class="logo">
                                <img src="/assets/images/symbols/BI.png" alt="logo" />
                            </h1>
                            <div class="txt__area" style="display: absolute">
                                <div class="text-h8 text-bold">
                                    <p class="summary">KReaD 기반의 국어 지식맵과 수능유형 트레이닝</p>
                                    <h4 class="text-bold">
                                        KReaD로 독해 실력을
                                        <span class="text-bold text-primary">수능 1등급까지 한번에 UP!</span>
                                    </h4>
                                    <p class="tx100">
                                        수능독해트레이닝은 KReaD 기반의 단계별 지문과 국어 지식맵을 바탕으로 학습자 수준에 맞는 드릴 학습을 제공합니다. <br />
                                        다양한 문학 작품과 전문성이 높은 비문학 글을 경험하여 낯선 지문에 대한 적응력을 높여 주고, 수능 베이직&심화 유형을 완벽히 트레이닝할 수 있습니다.
                                    </p>
                                </div>
                            </div>

                            <div class="img__area">
                                <q-btn flat class="transparent" @click="onInfoKread" style="right: 100px">
                                    <img src="/assets/images/symbols/info_kread.png" alt="kread logo" />
                                </q-btn>
                                <div class="symbols">
                                    <img src="/assets/images/symbols/intro_eval.png" alt="diagnostic_login_left" />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col col--right">
                        <div class="login__content">
                            <div>
                                <p class="txBold100">
                                    진단평가를 위한<br />
                                    정보를 입력해 주세요.
                                </p>
                            </div>

                            <q-form ref="loginFormRef" style="margin: 0 auto">
                                <q-input outlined v-model="wNick" class="icon-none" placeholder="닉네임을 입력해 주세요." :rules="[validZeroLength, validMinLength, validMaxLength]"> </q-input>

                                <q-select
                                    outlined
                                    class="icon-none"
                                    v-model="wGrade"
                                    bg-color="white"
                                    :options="optionsGrade"
                                    popup-content-class="b3"
                                    option-value="value"
                                    option-label="label"
                                    option-disable="inactive"
                                    label="학년"
                                    :rules="[(val) => (val && val.label !== '') || '학년을 선택해 주세요.']"
                                >
                                </q-select>

                                <q-input
                                    outlined
                                    class="col q-mr-sm icon-none"
                                    style="width: 100%; margin: 2px 0 0 0"
                                    bg-color="white"
                                    v-model="wAcadCode"
                                    hint=""
                                    placeholder="코드"
                                    :dense="false"
                                    @keyup.enter="onLogin"
                                    :rules="[(val) => (val && val.length > 0) || '코드를 입력해 주세요.', validAcademyCode]"
                                />
                            </q-form>

                            <CqBtn class="btn" color="primary" label="저장 후 평가 시작" :disable="isDisableSubmitBtn" @click="onLogin" />
                        </div>
                    </div>
                </div>
            </q-page>
        </q-page-container>
    </q-layout>

    <q-dialog v-model="popInfo" class="modal">
        <q-card class="modal__wrap">
            <q-card-section class="row items-center q-pb-none">
                <q-space />
                <q-icon name="close" align="right" class="modal--close" @click="popInfo = false" />
            </q-card-section>

            <q-card-section>
                <q-space />
                <div class="modal__content">
                    <h2 class="modal__title">
                        <span class="text-primary">국내 최초 한국어 독해 지수 </span>
                        <span class="kread__logo">
                            <img src="/assets/images/symbols/logo_kread_text.png" />
                        </span>
                    </h2>
                    <p class="tx50 modal__txt">
                        크리드(KReaD)는 글의 난이도와 학습자의 읽기 능력 수준을<br />
                        <span class="text-primary">AI로 측정한 ‘한국어 독해 지수’입니다. </span>
                        크리드 지수가 높을수록 글의 난이도가 높고, 학습자의 읽기 능력<br />
                        수준이 뛰어남을 나타냅니다. (특허 제 10-2201709호)
                    </p>
                    <div class="modal__img">
                        <p class="tx50">내 읽기 수준에 맞는 글을 읽어야 한다는<br />생각으로 만든 <span class="text-bold">'한국어 독해 지수' </span></p>
                        <p class="grade__img">
                            <img src="/assets/images/symbols/eval_info_grade.png" />
                        </p>
                    </div>
                </div>
            </q-card-section>
        </q-card>
    </q-dialog>
</template>

<script setup>
import { ref, watch, computed, onMounted } from 'vue';
import EvalIntro from '@/views/eval_login/EvalIntro.vue';

// import { schoolApi } from './school_api.js';
import { getAcademyCode, apiLogin4NonMember } from '@/api/modules/eval_api.js';
import CqBtn from '@/components/quasar/cqBtn.vue';
import { DialogStore } from '@/store/modules/dialog';
import { GlobalStore } from '@/store';
import { StudyStore } from '@/store/modules/study';
import { useRouter, useRoute } from 'vue-router';

import { useQuasar } from 'quasar';
import Comm from '@/components/common.js';
import { optionsGrade } from '@/helpers/constants.js';
// import { moveGrowthplateHome } from '@/helpers/common';

console.log('----evalogin----26553');
const $q = useQuasar();

const dStore = DialogStore();
const sStore = StudyStore();
const route = useRoute();
const router = useRouter();
const gStore = GlobalStore();

const showIntro = ref(false);
const popInfo = ref(false);
const loginFormRef = ref(null);
const schoolFormRef = ref(null);
const wNick = ref('');
const wAcadCode = ref('');
const wGrade = ref(null); // 학년(등급)

const isDisableSubmitBtn = ref(true);
const loginData = ref();

const onInfoKread = () => {
    popInfo.value = !popInfo.value;
};

watch([wNick, wGrade, wAcadCode], (aa, bb) => {
    // console.log('watch', aa, bb);
    isDisableSubmitBtn.value = !(wNick.value && wGrade.value && wAcadCode.value);
});

///////////////////////----submit----///////////////////////
const onLogin = async () => {
    dStore.openMsg(`교사용 성장판에서 로그인해주세요!교사용성장판에서 비회원의 체험계정을 생성하시면 KReaD 진단평가를 실시할 수 있습니다.`, (val) => {});
};

const onOpenIntro = (data) => {
    loginData.value = data;
    showIntro.value = true;
    gStore.setIsMemberEval(false); // 비회원 진단평가 시작.
};
const gotoEvalTest = () => {
    const data = loginData.value;
    // console.log('gStore.accessToken_eval:', data.data.accessToken);
    // console.log('gStore.refreshToken_eval:', data.data.refreshToken);
    gStore.setTokenForEval(data.data.accessToken);
    gStore.setReTokenForEval(data.data.refreshToken);
    gStore.setVersionForEval(data.data.version);

    gStore.setToken(''); // 회원 토큰 제거.
    // console.log('gStore.evalData:', gStore.evalData);
    router.push('/eval-test');
};

///////////////////////----유효성검사----///////////////////////
const pattern_kor = /[ㄱ-ㅎ|ㅏ-ㅣ|가-힣]/; // korean
const pattern_eng = /[a-zA-Z]/; // alphabet
const pattern_spc = /[~!@#$%^&*()_+|<>?:{}]/; // sign
const pattern_num = /[0-9]/; // number
const pattern_upper = /^[A-Z]+$/; // 영문 대문자만
const pattern_lower = /^[a-z]+$/; // 영문 소문자만

const limitMin = 2;
const limitMax = 16;
const validLower = (val) => (pattern_lower.test(val) ? '유효한 센터ID를 입력해 주세요.' : true);
// const validAcademyCode = (val) => (val.length !== 8 ? '센터ID는 AA+숫자 6자리입니다.' : true);
const validAcademyCode = (val) => (val.length < 7 || val.length > 12 ? '센터 코드 7자리 ~ 12자리를 입력해 주세요.' : true);
// const validAcademyCode = (val) => (val.length !== 12 ? '솔루니 선생님께 전달받은 12자리 코드를 입력해 주세요.' : true);
const validZeroLength = (val) => (!val ? `닉네임을 입력해 주세요.` : true);
const validMinLength = (val) => (val.length < limitMin ? `한글 또는 영문 ${limitMin}~${limitMax}자로 입력해 주세요.` : true);
const validMaxLength = (val) => (val.length > limitMax ? `한글 또는 영문 ${limitMin}~${limitMax}자로 입력해 주세요.` : true);
const validDenyKorean = (val) => (pattern_kor.test(val) ? '한글은 적을 수 없습니다.' : true);
const validDenyEnglish = (val) => (pattern_eng.test(val) ? '알파벳은 적을 수 없습니다.' : true);
const validDenySign = (val) => (pattern_spc.test(val) ? '특수문자는 적을 수 없습니다.' : true);
const validDenyNumber = (val) => (pattern_num.test(val) ? '숫자는 적을 수 없습니다.' : true);
const validIncludeAt = (val) => (!(val.includes('@') && val.includes('.')) ? '유효한 이메일을 입력해 주세요.' : true);
const validPhoneNo = (val) => (pattern_eng.test(val) || pattern_spc.test(val) || pattern_kor.test(val) ? '숫자와 하이픈(-)만 적을 수 있습니다.' : val.length < 9 ? '유효한 전화번호를 입력해 주세요.' : true);

onMounted(() => {
    gStore.initStore();
    sStore.initStore();
    Comm.setDeviceType();

    dStore.openMsg(`교사용 성장판에서 로그인해주세요!교사용성장판에서 비회원의 체험계정을 생성하시면 KReaD 진단평가를 실시할 수 있습니다.`, (val) => {
        // moveGrowthplateHome();

        if (typeof window.PanApp?.sendErrToAndroid === 'function') {
            window.PanApp.sendErrToAndroid('Home');
        }
    });
});
</script>

<style scoped lang="scss">
p,
h4,
h5,
div {
    margin: 0;
    font-family: 'Noto Sans CJK KR', Helvetica, sans-serif;
}

// tttb
button:disabled,
button[disabled] {
    // border: 1px solid #999999;
    background-color: #cccccc;
    color: #666666;
}

button {
    background-color: #00a2e0;
    color: #fff;
}

img {
    width: 100%;
}

.transparent {
    background-color: transparent;
}

:host(.read-only) [part='input-field']::after {
    border-style: solid;
    border-width: thin;
    border-color: grey;
}

///////////commoncode///////////
.modal {
    color: #222222;

    .title {
        color: #222222;
        font-size: 2.1vmin;
        font-weight: 700;
        margin: 1.75vmin 0vmin 0.5vmin;
        display: flex;
        justify-content: space-between;
        align-items: center;
    }

    &__wrap {
        width: 50vw;
        min-width: 500px;
        max-width: 1000px;
        border-radius: 2.5vmin;
    }

    &__checkbox ::v-deep {
        font-size: 1.6vmin;
    }

    .q-option-group ::v-deep {
        .q-checkbox__bg {
            border-radius: 50% !important;
        }
    }

    .q-checkbox ::v-deep {
        .q-checkbox__bg {
            border-radius: 50% !important;
        }
    }

    .btn {
        border-radius: 1vmin;
        margin-bottom: 2vmin;
    }

    .close {
        margin: 1.5vmin;
    }

    .q-option-group {
        ::v-deep > div {
            width: 23%;
        }
    }

    &--close {
        position: absolute;
        top: 2.67vmin;
        right: 2.67vmin;
        font-size: 2.4vw;
        cursor: pointer;
    }

    &__txt {
        margin-top: 0.92vmin;
        font-size: 1.3vw;
        line-height: 2.1vw;

        .text-primary {
            display: block;
            font-weight: 500;
        }
    }

    &__img {
        margin-top: 2.67vmin;
        padding: 3.33vmin 6.67vmin 2.83vmin;
        border-radius: 2.67vmin;
        background: $color_gray_200;

        .tx50 {
            font-size: 1.3vw;
            text-align: center;
            line-height: 2.1vw;
        }

        .grade__img {
            //margin-top: 2vmin;
            width: 90%;
            margin: 0.8vmin auto 0;
        }
    }

    h2 {
        font-size: 1.8vw;
        text-align: center;
        line-height: 2.6vw;

        .text-primary {
            font-weight: 700;
        }
    }

    .q-card {
        &__section {
            padding: 6.07vmin 3vmin 3vmin;

            &.items-center {
                padding: 0;
                z-index: 5;
            }
        }
    }

    .kread__logo {
        display: inline-block;
        width: 14%;
        max-width: 136px;

        img {
            vertical-align: bottom;
        }
    }
}

.icon-none {
    ::v-deep .q-field__append {
        display: none;
    }
}

.col {
    color: #222222;

    &--left {
        position: relative;
        flex: 0 0 auto;
        width: 47%;
        min-width: 300px;
        max-width: 930px;
        height: 100vh;
        background: #f2f5f7;
        font-family: 'Noto Sans CJK KR', Helvetica, sans-serif;

        h4 {
            margin-top: 0.67vmin;
            font-size: 2.3vw;
            line-height: 3.3vw;

            span {
                display: block;
            }
        }

        button {
            padding: 0;
        }

        .txt {
            &__area {
                //margin: 6vmin 12.17vmin 0 7.83vmin;
                //margin: 4.5vmin 0 0;
                padding-top: 10.67vmin;

                .tx100 {
                    width: 81%;
                    max-width: 690px;
                    word-break: keep-all;
                }
            }
        }

        .tx100 {
            margin-top: 2.67vmin;
            font-size: 1.3vw;
            text-align: left;
            line-height: 2.1vw;
        }
    }

    &--right {
        position: relative;
        height: 100vh;
        font-family: 'Noto Sans CJK KR', Helvetica, sans-serif;
    }
}

.logo {
    position: absolute;
    top: 0;
    left: -4.5vmin;
    width: 45%;
    max-width: 277.23px;
    //margin: 1.5vmin 3.33vmin 0;
    //margin: 1.5vmin 0 0;
    font-size: inherit;
    line-height: inherit;

    &__content {
        position: absolute;
        top: 50%;
        //left: 50%;
        right: 0;
        width: 100%;
        //max-width: 600px;
        //max-width: 670px;
        max-width: 41.8vw;
        word-break: keep-all;
        //@include transform(translate(-50%, -50%));
        @include transform(translateY(-50%));
    }
}

.summary {
    font-size: 1.3vw;
    color: $color_gray_600;
    line-height: 2.1vw;
}

.img {
    &__area {
        position: relative;
        //margin-top: 4.17vw;
        margin-top: 3.17vw;

        button {
            position: absolute;
            top: 0;
            left: 0;
            width: 27%;
            max-width: 176px;

            &:hover {
                .q-focus-helper {
                    background: inherit !important;
                }
            }
        }

        .symbols {
            //width: 90%;
            //width: 74%;
            width: 100%;
            margin: 0 auto;
        }
    }
}

.login {
    &__content {
        position: absolute;
        top: 50%;
        left: 50%;
        width: 59%;
        max-width: 600px;
        @include transform(translate(-50%, -50%));

        .txBold100 {
            margin-bottom: 3.83vmin;
            font-size: 2.3vw;
            text-align: left;
            line-height: 3.3vw;
        }

        button {
            width: 100%;
            padding: 1.6vw;
            @include border-radius(1vmin);
            font-size: 1.2vw;
            line-height: 1.6vw;
            opacity: 1 !important;
        }
    }
}

::v-deep {
    input {
        padding: 1.6vw;
        font-size: 1.2vw;
        color: $color_gray_900;
        line-height: 1.6vw;

        ::placeholder {
            color: $color_gray_600;
        }
    }

    .q {
        &-field {
            margin-top: 0px;

            &__bottom {
                font-size: 1.1vw;
                font-weight: 500;
                line-height: 1.4vw;

                &--animated {
                    padding-top: 5px;
                }
            }

            &__control {
                border-radius: 1vmin;
                height: 100%;
            }

            &__label {
                top: 50%;
                left: 1.6vw;
                font-size: 1.2vw;
                color: $color_gray_600;
                line-height: 1.6vw;
                transform: translateY(-50%);
            }

            &--with-bottom {
                //padding-bottom: 3vmin;
                padding-bottom: 1.8vw;
            }

            &--float {
                .q-field__label {
                    top: 0.8vw;
                    font-size: 0.8vw;
                    @include transform(translateY(-40%));
                }
            }
        }

        &-item__label {
            font-size: 24px;
        }
    }

    .q-field--auto-height.q-field--labeled .q-field__control-container {
        padding: 1.6vw;
        background: url('@/assets/images/icon/ico_down.svg') no-repeat center right/ 2.1vw;
        font-size: 1.2vw;
        color: $color_gray_900;
        line-height: 1.6vw;
    }

    .q-field--auto-height.q-field--labeled.q-field--focused .q-field__control-container {
        background: url('@/assets/images/icon/ico_up.svg') no-repeat center right/ 2.1vw;
    }

    .q-field--auto-height.q-field--labeled .q-field__native {
        min-height: 1.6vw;
        padding-bottom: 0;
    }
}

@media all and (max-height: 999px) {
    .img__area {
        .symbols {
            width: 80%;
        }
    }
    .modal {
        .grade__img {
            width: 78%;
            margin: 0 auto;
        }
    }
}

@media all and (max-height: 600px) {
    img {
        display: none;
    }
}
/*
@media screen and (min-width: $desktop_full_width + 1) {
    .img__area {
        .symbols {
            width: 100%;
        }
    }
}

@include pc_size_l {
    .img__area {
        .symbols {
            width: 100%;
        }
    }
}
*/
</style>
